import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { ApiService } from "../../services/api.service";
import { RETRIEVE_ACQUISISCI_BOLLA, RETRIEVE_ACQUISISCI_BOLLA_SUCCESS, RETRIEVE_ANNULLA_BOLLA, RETRIEVE_ANNULLA_BOLLA_SUCCESS, RETRIEVE_BOLLA, RETRIEVE_BOLLA_POST, RETRIEVE_BOLLA_POST_NO_PALMARE, RETRIEVE_BOLLA_POST_NO_PALMARE_SUCCESS, RETRIEVE_BOLLA_POST_SUCCESS, RETRIEVE_BOLLA_SUCCESS, RETRIEVE_CONSEGNA_SENZA_PALMARE, RETRIEVE_CONSEGNA_SENZA_PALMARE_SUCCESS, RETRIEVE_MAGAZZINO_CONTATORI, RETRIEVE_MAGAZZINO_CONTATORI_SUCCESS, RETRIEVE_MAGAZZINO_PICKUP, RETRIEVE_MAGAZZINO_PICKUP_DELETE, RETRIEVE_MAGAZZINO_PICKUP_DELETE_SUCCESS, RETRIEVE_MAGAZZINO_PICKUP_SUCCESS, RETRIEVE_STAMPA_SCONTRINO_RITIRO, RETRIEVE_STAMPA_SCONTRINO_RITIRO_SUCCESS } from "./courier-activities.actions";
import { switchMap, map, catchError, throwError } from "rxjs";
import { IResponseRetrieveBolla } from "../../interfaces/response-retrieve-bolla";
import { IResponseMagazzinoPickup } from "../../interfaces/response-magazzino-pickup";
import { IBollaPostResponse } from "../../interfaces/bolla-post";
import { IMagazzinoContatoriResponse } from "../../interfaces/magazzino-contatori";
import { IStampaScontrinoRitiroResponse } from "../../interfaces/stampa-scontrino-ritiro";
import { IAcquisisciBollaResponse, IAnnullaBolla } from "../../interfaces/acquisisci-bolla";
import { Store } from "@ngrx/store";
import { ADD_MESSAGE } from "../messages/messages.actions";
import { HttpErrorResponse } from "@angular/common/http";

@Injectable()
export class CourierActivitiesEffects {

  retrieveBolla$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_BOLLA),
      switchMap(() => this.api.retrieveBolla()),
      map((responseRetrieveBolla: IResponseRetrieveBolla) => {
        return RETRIEVE_BOLLA_SUCCESS({ responseRetrieveBolla });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveMagazzinoPickup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_MAGAZZINO_PICKUP),
      switchMap(() => this.api.retrieveMagazzinoPickup()),
      map((responseMagazzinoPickup: IResponseMagazzinoPickup) => {
        return RETRIEVE_MAGAZZINO_PICKUP_SUCCESS({ responseMagazzinoPickup });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveBollaPost$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_BOLLA_POST),
      switchMap(({payloadBollaPost}) => this.api.retrieveBollaPost(payloadBollaPost)),
      map((responseRetrieveBollaPost: IBollaPostResponse) => {
        return RETRIEVE_BOLLA_POST_SUCCESS({ responseRetrieveBollaPost });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveMagazzinoContatori$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_MAGAZZINO_CONTATORI),
      switchMap(() => this.api.retrieveMagazzinoContatori()),
      map((responseMagazzinoContatori: IMagazzinoContatoriResponse) => {
        return RETRIEVE_MAGAZZINO_CONTATORI_SUCCESS({ responseMagazzinoContatori });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveStampaScontrinoRitiro$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_STAMPA_SCONTRINO_RITIRO),
      switchMap(({params}) => this.api.retrieveStampaScontrinoRitiro(params)),
      map((responseStampaScontrinoRitiro: IStampaScontrinoRitiroResponse) => {
        return RETRIEVE_STAMPA_SCONTRINO_RITIRO_SUCCESS({ responseStampaScontrinoRitiro });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveAcquisisciBolla$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_ACQUISISCI_BOLLA),
      switchMap(({payload}) => this.api.retrieveAcquisisciBolla(payload)),
      map((responseAcquisisciBolla: IAcquisisciBollaResponse) => {
        return RETRIEVE_ACQUISISCI_BOLLA_SUCCESS({ responseAcquisisciBolla });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveBollaPostNoPalmare$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_BOLLA_POST_NO_PALMARE),
      switchMap(({payload}) => this.api.retrieveBollaPost(payload)),
      map((responseBollaPostNoPalmare: IBollaPostResponse) => {
        return RETRIEVE_BOLLA_POST_NO_PALMARE_SUCCESS({ responseBollaPostNoPalmare });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveMagazzinoPickupDelete$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_MAGAZZINO_PICKUP_DELETE),
      switchMap(({payload}) => this.api.retrieveMagazzinoPickupDelete(payload)),
      map((responseDeleteMagazzinoPickup: IResponseMagazzinoPickup) => {
        return RETRIEVE_MAGAZZINO_PICKUP_DELETE_SUCCESS({ responseDeleteMagazzinoPickup });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveAnnullaBolla$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_ANNULLA_BOLLA),
      switchMap(() => this.api.retrieveAnnullaBolla()),
      map((responseAnnullaBolla: IAnnullaBolla) => {
        return RETRIEVE_ANNULLA_BOLLA_SUCCESS({ responseAnnullaBolla });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  retrieveConsegnaSenzaPalmare$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RETRIEVE_CONSEGNA_SENZA_PALMARE),
      switchMap(() => this.api.retrieveConsegnaSenzaPalmare()),
      map((responseConsegnaSenzaPalmare: IAnnullaBolla) => {
        return RETRIEVE_CONSEGNA_SENZA_PALMARE_SUCCESS({ responseConsegnaSenzaPalmare });
      }),
      catchError((error: HttpErrorResponse) => {
        this.addErrorMessage(error.message)
        return throwError({ error });
      })
    )
  );

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private router: Router,
    private store: Store
  ) {}

  private addErrorMessage(message: string): void {
    this.store.dispatch(ADD_MESSAGE({ message: message }));
  }
}
